/*
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   BottomHalf/styles.ts
 */

import { css } from '@emotion/react'
import { BREAKPOINT_MOBILE } from '@zcode-ui/themes'

export const localLogic = css`
  max-width: none;
  padding: 0;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    padding: 0;
  }

  @media (min-width: 771px) and (max-width: 869px) {
    padding: 0;
  }

  @media (min-width: 870px) and (max-width: 1219px) {
    padding: 0;
  }
`

export const poi = css`
  max-width: none;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    margin-left: 0;
    margin-right: 0;
  }
`
